import { j as o } from "../../../../jsx-runtime.BREq8dyb.js";
import { Chip as i, Box as t, Typography as e } from "@mui/joy";
import { memo as s } from "react";
import { mapCombinatorOperatorToIcon as n, mapCombinatorOperatorToPresentation as p } from "../../config.js";
const a = s(({
  operator: r
}) => {
  const m = n[r];
  return /* @__PURE__ */ o.jsx(i, { size: "lg", sx: {
    my: 1
  }, children: /* @__PURE__ */ o.jsxs(t, { alignItems: "center", display: "flex", children: [
    /* @__PURE__ */ o.jsx(m, { width: "20px" }),
    /* @__PURE__ */ o.jsx(e, { level: "body-sm", ml: 0.5, children: p[r] })
  ] }) });
});
a.displayName = "CombinatorChip";
export {
  a as default
};
//# sourceMappingURL=CombinatorChip.js.map
